@if (isLoadingLabelVisible) {
  <div id="loaderModal" class="modal">
    <div class="modal-content">
      <p>{{loaderMessage}}</p>
    </div>
  </div>
}

<div class="m-0" id="aichatinput">
  <p class="m-0 title">
    {{chatTitle}}
  </p>
  <p>
    <small class="subtitle">Chatbot knows only what is inside your content. Its knowledge is limited and may be biased. </small>
    @if (dynamicSearch == true) {
      <small class="subtitle">Wroolo is searching for answer in your content each time you send a new question. This may take more time. If you want to speed up the process, search documents first with AI search in the header, and then check those you want to use for chat.</small>
    }
  </p>
  @if (chatComments.length > 0) {
    <div class="my-2">
      <ul class="list-group list-group-flush">
        @for (com of chatComments; track com) {
          <li class="list-group-item">
            @if (com.isAI == false) {
              USER:
            }
            @if (com.isAI == true) {
              AI:
            }
            <span [innerHTML]="com.content"></span>
          </li>
        }
        @if (isAIThinking == true) {
          <li class="list-group-item">
            AI:
            <span class="eos-icons--rotating-gear"></span>
            {{aiThinkingMessage}}
          </li>
        }
      </ul>
    </div>
  }
  @if (isAIThinking == false) {
    <div class="input-group mb-3 form-group-sm my-4 position-relative">
      <input class="form-control input-sm" type="search" placeholder="Type your prompt" [(ngModel)]="userComment" name="userComment" (keydown.enter)="sendComment(userComment)" autocomplete="off" data-lpignore="true" data-form-type="other">
      <button class="btn btn-outline-secondary" (click)="sendComment(userComment)" data-bs-toggle="tooltip" data-bs-placement="top" title="Send your question or comment to chatbot" data-bs-delay="{show: 1000}">
        <span class="hugeicons--chat-bot"></span>
      </button>
      <button class="btn btn-outline-secondary" (click)="clearComments()" data-bs-toggle="tooltip" data-bs-placement="top" title="Clear whole topic and start over" data-bs-delay="{show: 1000}">
        <i class="bi bi-trash3"></i>
      </button>
      <button class="btn btn-outline-secondary" type="button" (click)="openPromptCatalog()" data-bs-toggle="tooltip" data-bs-placement="top" title="Open catalog" data-bs-delay="{show: 1000}">
        <span class="carbon--catalog"></span>
      </button>
      @if (isPromptCatalogOpened == true) {
        <app-promptcatalogpopup [organizationKey]="organizationKey" (selectedPrompt)="onSelectedPrompt($event)"></app-promptcatalogpopup>
      }
    </div>
  }
</div>

@if (chats.length > 0 && showChatHistory == true) {
  <div class="title-history">
    Chat history
  </div>
  <div class="my-2 chat-container">
    <div class="m-2 p-1 chat-list">
      @for (chat of chats; track chat.chatKey) {
        <div (click)="selectedChatKey = chat.chatKey" class="pointer p-1" [ngClass]="{'selected': selectedChatKey == chat.chatKey}">
          {{chat.dateOfUpdate | date: 'dd.MM.yyyy HH:mm:ss'}}
          <button class="btn my-btn" (click)="deleteChat(chat.chatKey)" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete chat" data-bs-delay="{show: 1000}">
            <i class="mdi--delete-outline"></i>
          </button>
          <button class="btn my-btn" (click)="continueChat(chat.chatKey)" data-bs-toggle="tooltip" data-bs-placement="top" title="Continue chat" data-bs-delay="{show: 1000}">
            <i class="material-symbols--gesture-select-outline"></i>
          </button>
        </div>
      }
    </div>
    <div class="m-1 chat-content">
      @for (chat of chats; track chat.chatKey) {
        @if (selectedChatKey == chat.chatKey) {
          <div>
            @for (com of chat.chatComments; track com) {
              <div class="chat-message">
                @if (com.isAI == false) {
                  USER:
                }
                @if (com.isAI == true) {
                  AI:
                }
                <span [innerHTML]="com.content"></span>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}